import React, { useCallback, useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import axiosInstance from '../../../utils/axiosConfig';
import AparatosPanel from '../AparatosPanel';
import { Cargando, botonClaro, display, panel } from '../ui';

const REFRESCO_MS = 5000;

const AparatosVista = () => {
    const [aparatos, setAparatos] = useState(null);
    const [ocultos, setOcultos] = useState([]);
    const [error, setError] = useState(null);
    const montado = useRef(true);

    const cargar = useCallback(async () => {
        try {
            const [{ data }, { data: todos }] = await Promise.all([
                axiosInstance.get('/api/asistencia/aparatos'),
                axiosInstance.get('/api/asistencia/configuracion/aparatos'),
            ]);
            if (!montado.current) return;
            setAparatos(data.aparatos);
            setOcultos(todos.aparatos.filter((a) => !a.activo));
            setError(null);
        } catch (e) {
            if (montado.current) setError('No se pudo leer el estado de los aparatos. Se reintenta solo en unos segundos.');
        }
    }, []);

    useEffect(() => {
        montado.current = true;
        cargar();
        const t = setInterval(cargar, REFRESCO_MS);
        return () => { montado.current = false; clearInterval(t); };
    }, [cargar]);

    const mostrar = async (a) => {
        try {
            await axiosInstance.patch(`/api/asistencia/aparatos/${a.id}`, { activo: true });
            cargar();
        } catch (e) {
            toast.error('No se pudo mostrar el aparato');
        }
    };

    const conectados = (aparatos || []).filter((a) => a.conectado).length;
    return (
        <div className="space-y-6">
            <header>
                <h1 className={`${display} text-3xl font-bold text-slate-900`}>Aparatos</h1>
                <p className="text-sm text-slate-500 mt-1">
                    {aparatos ? `${conectados} de ${aparatos.length} conectados a Centro SURA. ` : ''}
                    Cada aparato marca, guarda su memoria y recibe las altas y bajas de personal desde aquí.
                </p>
            </header>
            {error && <p className="text-sm text-rose-600">{error}</p>}
            {!aparatos ? <Cargando /> : <AparatosPanel aparatos={aparatos} onCambio={cargar} />}
            {ocultos.length > 0 && (
                <section className="space-y-2">
                    <h2 className="text-sm font-semibold text-slate-900">Ocultos</h2>
                    <div className={`${panel} divide-y divide-slate-100`}>
                        {ocultos.map((a) => (
                            <div key={a.id} className="px-5 py-3 flex items-center gap-4">
                                <p className="text-sm text-slate-700 flex-1">
                                    {a.nombre} <span className="text-xs text-slate-400 tabular-nums">{a.serial}</span>
                                </p>
                                <button type="button" onClick={() => mostrar(a)} className={botonClaro}>Mostrar</button>
                            </div>
                        ))}
                    </div>
                </section>
            )}
        </div>
    );
};

export default AparatosVista;
